import React from 'react';
export function Benefits() {
  const benefits = [{
    emoji: '🍮',
    text: 'Pasarás de "ojalá me salga" a tener una base infalible para flanes lisos, cremosos y firmes (sin horno, sin problemas).'
  }, {
    emoji: '⏱️',
    text: 'Aprenderás a producir por tandas: hacer 10 flanes en el tiempo en que antes hacías 1 al horno. Volumen = ganancia.'
  }, {
    emoji: '💸',
    text: 'Tendrás sabores que la gente ya compra (porque el flan es el postre #1 en la mesa familiar) y que te permiten vender toda la semana, no solo "cuando se te ocurre".'
  }, {
    emoji: '🔥',
    text: 'Vas a cocinar sin sufrir el horno: sin baño María, sin esperar horas, sin estar lavando moldes pegados.'
  }, {
    emoji: '📲',
    text: 'Y además, tendrás guiones listos para vender por WhatsApp/estados sin vergüenza, sin sonar insistente.'
  }];
  return <section className="py-10 md:py-20 px-4 bg-cream" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-brown-dark mb-8 md:mb-12" data-id="element-19">
          ¿Qué lograrás con este método?
        </h2>

        <div className="grid gap-4 md:gap-6" data-id="element-20">
          {benefits.map((benefit, index) => <div key={index} className="flex items-start bg-white p-5 md:p-6 rounded-xl shadow-sm border-l-4 border-success-green hover:shadow-md transition-shadow" data-id="element-21">
              <div className="text-3xl mr-5 flex-shrink-0 bg-cream-dark w-14 h-14 flex items-center justify-center rounded-full" data-id="element-22">
                {benefit.emoji}
              </div>
              <p className="text-lg text-gray-800 font-medium pt-1 leading-relaxed" data-id="element-23">
                {benefit.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}